import React from 'react';
import type { FC } from 'react';
import { tw } from 'twind';
import { useCartStore } from 'store/cart';

export const ActionBar: FC = ({ children }) => {
  const { theme } = useCartStore();

  return (
    <div className={tw`fixed bottom-0 w-full shadow-action-bar z-10`}>
      {children}

      <div className={tw` bg-white p-4 w-full flex align-middle items-center`}>
        <div className={tw`text-xs text-[#777777]`}>Powered by CreatorCart™</div>
        <div className={tw`items-end flex flex-col flex-grow mr-3`}>
          <div className={tw`text-xs text-right text-${theme}-primary`}>Use product links in list to order</div>
        </div>
      </div>
    </div>
  );
};
